import { computed, makeObservable } from 'mobx'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'
import { Model } from 'modules/core/lib/mobx-rest'

export declare type PlanningTool = 'contract_hours' | 'work_schedule' | 'shift_management'

export const PLANNING_TOOL = Object.freeze({
  contractHours: 'contract_hours',
  workSchedule: 'work_schedule',
  shiftManagement: 'shift_management',
})

interface IPlanningVersion {
  id: string
  effective_at: string
  planning_tool: PlanningTool
  employee_id: string
  work_schedule_schedule_id: string | null
  number_of_rest_days_in_cents: number | null
  default: boolean
}
class PlanningVersion extends Model<IPlanningVersion> {
  constructor(attr: IPlanningVersion) {
    super(attr)

    makeObservable(this, {
      isDefault: computed,
      effectiveAt: computed,
      planningTool: computed,
      isContractHoursTool: computed,
      isWorkScheduleTool: computed,
      isShiftManagementTool: computed,
      future: computed,
    })
  }

  static urlRoot() {
    return '/time_planning/planning_versions'
  }

  get isDefault(): boolean {
    return this.attributes.default
  }

  get effectiveAt(): moment.Moment {
    return stringToDate(this.attributes.effective_at, 'backend')
  }

  get planningTool(): string {
    return this.attributes.planning_tool
  }

  get isContractHoursTool(): boolean {
    return this.planningTool === PLANNING_TOOL.contractHours
  }

  get isWorkScheduleTool(): boolean {
    return this.planningTool === PLANNING_TOOL.workSchedule
  }

  get isShiftManagementTool(): boolean {
    return this.planningTool === PLANNING_TOOL.shiftManagement
  }

  get future(): boolean {
    return this.effectiveAt.isAfter(moment(), 'day')
  }
}

export default PlanningVersion
